<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " style="padding-bottom: 20px" v-loading="RiskLoding">
    <div id="g2ede8" class="operations-content">
      <h2 id="gf7b16" class="operations-head-content ">
        <div>
          <span class="operations-headspan">
            {{ $t("TradeByCountry.CountryTradeDataComparison") }} 
          </span>
        </div>
      </h2>
      <div class="flex_center_bettwen DataComparison_tab">
        <div>
          <div
            class="DataComparison cuspoint"
            :class="
              DataComparisonAcaive == index
                ? 'DataComparisonActive'
                : 'DataComparisonBlack'
            "
            v-for="(item, index) in DataComparisonList"
            @click="DataComparisonAcaiveIndex(item, index)"
            :key="item.id"
          >
            {{ $t("TradeByCountry.Comparison") }} {{ index + 1 }}
            <svg
              t="1766998282597"
              v-if="index > 0"
              @click="DeleteDataComparsion(item, index)"
              class="icon margin-left10"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8544"
              width="14"
              height="14"
            >
              <path
                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                fill="#FF6A6A"
                p-id="8545"
              ></path>
            </svg>
          </div>
        </div>
        <div
          style="color: #009ea7; cursor: pointer"
          @click="AddDataComparisonList()"
        >
          + {{ $t("TradeByCountry.AddSample") }}
        </div>
      </div>

      <div class="Product_Supply_select">
        <div class="data_comp_con_sear margin-bottom10">
          <div class="operations-head-content">
            <span class="operations-headspan"> {{ $t("TradeByCountry.AddCriteria") }}</span>
            <el-button
              style="background: #009ea7"
              :disabled="
                DataComparisonList[DataComparisonAcaive].conditions
                  ?.ExportingCountry?.length == 0 ||
                DataComparisonList[DataComparisonAcaive].conditions?.HsCode
                  ?.length == 0 ||
                DataComparisonList[DataComparisonAcaive].conditions
                  ?.ImportingCountry?.length == 0 ||
                DataComparisonList[DataComparisonAcaive].conditions?.datePicker
                  ?.length == 0
              "
              @click="toggleSearchReset"
              class="btn_export"
            >
              {{
                DataComparisonList[DataComparisonAcaive].isSearching
                  ? this.$t("SearchTrade.Reset")
                  : this.$t("TradeByCountry.ShowResult")
              }}
            </el-button>
          </div>
          <div>
            <div class="flex_center_bettwen margin-top20 width_100">
              <div class="flex_center_bettwen width_50">
                <span class="  data_select_lab">{{ $t("TradeByCountry.ExportCountry") }}:</span>
                <el-select
                  @change="getTradeTrendsFilterList(1)"
                  class="data_select margin-left20"
                  filterable
                  :popper-append-to-body="false"
                  v-model="
                    DataComparisonList[DataComparisonAcaive].conditions
                      .ExportingCountry
                  "
                  :placeholder="$t('TradeByCountry.Selectexportcountries')"
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                  ></el-option>
                </el-select>
              </div>
              <div class="flex_center_bettwen width_50">
                <span class="  data_select_lab">{{ $t("TradeByCountry.Product") }}:</span>
                <el-autocomplete
                  id="c308fb"
                  v-model="
                    DataComparisonList[DataComparisonAcaive].conditions.HsCode
                  "
                  ref="hsCodeAutocomplete"
                  class="data_select margin-left20"
                  @select="selectCountryTradeDataForAnalysis"
                  :highlight-first-item="true"
                  :trigger-on-focus="false"
                  :fetch-suggestions="querySearchAsync"
                  :hide-loading="true"
                  :placeholder="$t('TradeByCountry.EnterproductnameorHSCode')"
                  size="large"
                  suffix-icon="iconfont icon-search"
                >
                </el-autocomplete>
              </div>
            </div>
            <div class="flex_center_bettwen margin-top20 width_100">
              <div class="flex_center_bettwen width_50">
                <span class="  data_select_lab">{{ $t("TradeByCountry.ImportCountry") }}:</span>
                <el-select
                  @change="getTradeTrendsFilterList(1)"
                  :multiple="true"
                  class="data_select margin-left20"
                  filterable
                  :popper-append-to-body="false"
                  v-model="
                    DataComparisonList[DataComparisonAcaive].conditions
                      .ImportingCountry
                  "
                  :placeholder="$t('TradeByCountry.Selectimportcountries')"
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                    :disabled="
                      item.countryCode ==
                      DataComparisonList[DataComparisonAcaive]?.conditions
                        ?.ExportingCountry
                    "
                  ></el-option>
                </el-select>
              </div>
              <div class="flex_center_bettwen width_50">
                <span class="  data_select_lab">{{ $t("TradeByCountry.Date") }}:</span>

                <div class="data_select margin-left20 flex_center_bettwen">
                  <div v-show="false">{{ calDate }}  </div>
                  <el-date-picker
                    v-model="DataComparisonList[DataComparisonAcaive].conditions
                        .beginDate"
                    type="month"
                    :placeholder="$t('SearchTrade.Startdate')"
                    value-format="yyyy-MM" 
                    :picker-options="beginPickerOptions"
                    style="width:45%;"
                  />
                <span class="font18"> To</span> 
                    <el-date-picker
                    v-model="DataComparisonList[DataComparisonAcaive].conditions
                        .endDate"
                    type="month"
                    :placeholder="$t('SearchTrade.Enddate')"
                    value-format="yyyy-MM" 
                    :picker-options="endPickerOptions"
                    style="width:45%;"

                  />


                  <!-- <el-date-picker
                    v-model="
                      DataComparisonList[DataComparisonAcaive].conditions
                        .datePicker
                    "
                    class="data_select margin-left20"
                    type="monthrange"
                    range-separator=""
                    :start-placeholder="$t('SearchTrade.Startdate')"
                    value-format="yyyy-MM"
                    :end-placeholder="$t('SearchTrade.Enddate')"
                  ></el-date-picker> -->
              
              </div>
             </div>
            </div>
          </div>
        </div>

        <div
          class="flex_center_bettwen margin-top10 over_chart_title" 
          style="background-color: #ffffff"
          v-show="DataComparisonList[DataComparisonAcaive].hasData"
        >
          <span class="com_search_title">{{ $t("TradeByCountry.OverviewofAnalysisContent") }}: </span>
        </div>
        <div v-if="Arrlist.length > 0">
          <div
            ref="SupplyChainEchart"
            style="width: 100%; height: 540px; background-color: #ffffff"
          ></div>
        </div>
        <div class="flex_center trade_icon_tip_box" v-else>
          <div
            class="font999999 font20 text_center margin-top20 data_com_con_tip"
          >
            <div class="trade_icon_tip margin-bottom20">
              <i class="iconfont icon-tishi"></i>
            </div>
            {{ $t("TradeByCountry.Afterselectingthecriteria") }}
            <br />
            {{ $t("TradeByCountry.thecomparisonresultwillbedisplayed") }}
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import { getTradeTrends, getDataComparison } from "@/api/companyApi.js";
import { productSearch } from "@/api/searchApi.js";

import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      RiskLoding: false,
      Importyear: "",
      Country: "",
      companyList: [],
      Companyid: "",
      HsCodeList: [],
      activeIEports: "1",
      importTrendListEcharts: [],
      DataComparisonList: [
        {
          id: 0,
          name: this.$t("TradeByCountry.Comparison") + " 1",
          hasData: false, // 新增字段用于控制图表显示
          isSearching: false, // 新增字段用于控制按钮状态
          conditions: {
            ExportingCountry: "",
            HsCode: "",
            HsCodevalue: "",
            ImportingCountry: [],
            datePicker: [],
            beginDate:"",
            endDate:"",
          },
        },
      ],
 
       beginPickerOptions: {
        disabledDate: (time) => {
          const currentCondition =
          this.DataComparisonList[this.DataComparisonAcaive].conditions;
     
          if (!currentCondition.endDate) return false
          return time.getTime() > new Date(currentCondition.endDate).getTime()
        }
      },

      endPickerOptions: {
        disabledDate: (time) => {
          const currentCondition =
          this.DataComparisonList[this.DataComparisonAcaive].conditions;
     
          if (!currentCondition.beginDate) return false
          return time.getTime() < new Date(currentCondition.beginDate).getTime()
        }
      },

      DataComparisonAcaive: 0,
      reLoginVis: false,
      countryOptions: [],
      Arrlist: [],
      echartsSeveryear: ["2020", "2021", "2022", "2023", "2024"],
    };
  },
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: false,
    });
    this.getgetDataComparisonList();
    this.getCountry();
    this.$emit("UpdatamarkTotalList", true);

    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      this.suppleEchart();
    },

    toggleSearchReset() {
      if (this.DataComparisonList[this.DataComparisonAcaive].isSearching) {
        // 当前是搜索状态，点击后重置
        this.resetCurrentComparison();
      } else {
        // 当前是重置状态，点击后搜索
        this.getgetDataComparisonList();
      }
    },

    resetCurrentComparison() {
      // 重置当前比较条件
      const currentCondition =
        this.DataComparisonList[this.DataComparisonAcaive].conditions;
      currentCondition.ExportingCountry = "";
      currentCondition.HsCode = "";
      currentCondition.HsCodevalue = "";
      currentCondition.ImportingCountry = [];
      currentCondition.datePicker = [];
      currentCondition.beginDate="";
      currentCondition.endDate=""; 

      // 重置状态
      this.DataComparisonList[this.DataComparisonAcaive].hasData = false;
      this.DataComparisonList[this.DataComparisonAcaive].isSearching = false;

      // 清空图表数据
      this.Arrlist = [];
      this.echartsSeveryear = [];
      this.suppleEchart();
    },

    getgetDataComparisonList() {
      const currentCondition =
        this.DataComparisonList[this.DataComparisonAcaive].conditions;

      // 检查条件是否完整
      if (
        !currentCondition.ExportingCountry ||
        !currentCondition.HsCodevalue ||
        !currentCondition?.ImportingCountry?.length ||
        !currentCondition?.datePicker?.length
      ) {
        // 条件不完整时隐藏图表
        this.DataComparisonList[this.DataComparisonAcaive].hasData = false;
        this.Arrlist = [];
        this.echartsSeveryear = [];
        // this.suppleEchart();
        return;
      }
      this.RiskLoding = true;
      getDataComparison({
        exportCountryCode: [currentCondition.ExportingCountry],
        hsCode: currentCondition.HsCodevalue,
        importCountryCode: currentCondition.ImportingCountry,
        startMonth: currentCondition.datePicker[0],
        endMonth: currentCondition.datePicker[1],
      })
        .then((res) => {
          if (res.code == 200) {
            this.RiskLoding = false;
            // 验证数据结构
            if (!res.data || !Array.isArray(res.data)) {
              console.error("返回数据格式错误");
              this.DataComparisonList[
                this.DataComparisonAcaive
              ].hasData = false;
              this.Arrlist = [];
              this.echartsSeveryear = [];
              // this.suppleEchart();
              return;
            }
            const rawData = res.data;

            // 检查是否有数据
            if (!rawData || rawData.length === 0) {
              this.DataComparisonList[
                this.DataComparisonAcaive
              ].hasData = false;
              this.Arrlist = [];
              this.echartsSeveryear = [];
              // this.suppleEchart();
              return;
            }

            // 先确定所有月份，保持顺序，方便后面填充数据
            const allMonths = Array.from(
              new Set(rawData.map((item) => item.impYearMonth)),
            ).sort(); // 按年月升序

            // 按国家分组，构建对应的数据序列
            const countryMap = new Map(); // 使用Map提高查找效率

            // 定义默认配置
            const defaultSeriesConfig = {
              type: "line",
              stack: "Total",
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "rgba(18, 144, 201, 1)" },
                    { offset: 0.5, color: "rgba(0, 0, 255, 0.3)" },
                    { offset: 1, color: "rgba(0, 0, 255, 0)" },
                  ],
                },
              },
              emphasis: { focus: "series" },
              symbol: "",
              showSymbol: false,
              smooth: 0.5,
            };

            rawData.forEach(({ countryNameEn, impYearMonth, amount }) => {
              // 验证必要字段
              if (!countryNameEn) {
                console.warn("数据中缺少countryNameEn字段", {
                  countryNameEn,
                  impYearMonth,
                  amount,
                });
                return;
              }

              if (!countryMap.has(countryNameEn)) {
                countryMap.set(countryNameEn, {
                  name: countryNameEn,
                  data: Array(allMonths.length).fill(0), // 初始化为0
                  ...defaultSeriesConfig,
                });
              }

              // 找到impYearMonth对应的索引，填充数据
              const monthIndex = allMonths.indexOf(impYearMonth);
              if (monthIndex !== -1) {
                // 防止数组越界
                countryMap.get(countryNameEn).data[monthIndex] = amount ?? 0; // null 或 undefined 转0
              }
            });

            // 最终数组形式
            const Arrlist = Array.from(countryMap.values());
            this.echartsSeveryear = allMonths;
            // Arrlist 就是转换后的目标格式
            this.Arrlist = Arrlist;
            this.DataComparisonList[this.DataComparisonAcaive].hasData = true; // 设置有数据标志
            this.DataComparisonList[
              this.DataComparisonAcaive
            ].isSearching = true; // 设置搜索状态
            this.$nextTick(() => {
              this.suppleEchart();
            });
          } else {
            this.RiskLoding = false;
            console.error("接口返回错误码:", res.code);
            this.DataComparisonList[this.DataComparisonAcaive].hasData = false;
            this.Arrlist = [];
            this.echartsSeveryear = [];
            // this.suppleEchart();
          }
        })
        .catch((error) => {
          console.error("请求失败:", error);
          this.DataComparisonList[this.DataComparisonAcaive].hasData = false;
          this.Arrlist = [];
          this.echartsSeveryear = [];
          // this.suppleEchart();
        });
    },
    selectCountryTradeDataForAnalysis(item) {
      this.DataComparisonList[
        this.DataComparisonAcaive
      ].conditions.HsCodevalue = item.val;
    },
    querySearchAsync(queryString, cb) {
      // 只有当输入字符串长度大于0时才进行搜索和显示下拉
      if (queryString && queryString.trim().length > 0) {
        const params = {
          keyword: queryString.trim(), // 使用trim去除前后空格
        };
        productSearch(params)
          .then((res) => {
            const data = res.data;
            if (res.code) {
              data.forEach((item) => {
                item.val = item.hsCode;
                item.value = item.hsCodeDescription;
              });
              cb(data);
            } else {
              cb([]); // 没有结果时返回空数组
            }
          })
          .catch(() => {
            cb([]); // 错误时返回空数组
          });
      } else {
        // 输入为空时返回空数组，隐藏下拉
        cb([]);
      }
    },
    //获取国家
    getCountry() {
      this.countryOptions = JSON.parse(
        localStorage.getItem("countryList"),
      )[0].countryList;
    },
    DeleteDataComparsion(item, index) {
      if (this.DataComparisonList.length <= 1) return; // 至少保留一个
      this.DataComparisonList.splice(index, 1);
      if (this.DataComparisonAcaive >= index && this.DataComparisonAcaive > 0) {
        this.DataComparisonAcaive--;
      } else if (this.DataComparisonList.length > 0) {
        this.DataComparisonAcaive = Math.min(
          this.DataComparisonAcaive,
          this.DataComparisonList.length - 1,
        );
      }
      // 删除后重新渲染当前图表
      this.getgetDataComparisonList();
    },
    DataComparisonAcaiveIndex(item, index) {
      this.DataComparisonAcaive = index;
      // 切换后重新加载当前条件的数据
      this.getgetDataComparisonList();
    },
    AddDataComparisonList() {
      // 限制最多添加5个数据对比项
      if (this.DataComparisonList.length >= 5) {
        this.$message.warning(this.$t("TradeByCountry.Youcanonlyaddupto5datacomparisonitems"));
        return;
      }

      const newId = this.DataComparisonList.length;
      this.DataComparisonList.push({
        id: newId,
        name: this.$t("TradeByCountry.Comparison")+` ${newId + 1}`,
        hasData: false, // 新增标签页默认无数据
        isSearching: false, // 新增标签页默认未搜索
        conditions: {
          ExportingCountry: "",
          HsCode: "",
          HsCodevalue: "",
          ImportingCountry: [],
          datePicker: ["", ""],
        },
      });
      this.DataComparisonAcaive = newId;
      // 新增后清空图表和数据
      this.Arrlist = [];
      this.echartsSeveryear = [];
      this.suppleEchart();
    },
    SelectPicker() {
      this.DataComparisonList[this.DataComparisonAcaive].conditions.datePicker =
        this.DataComparisonList[
          this.DataComparisonAcaive
        ].conditions.datePicker.sort(function (a, b) {
          return a - b;
        });
      this.getTradeTrendsFilterList(0);
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getTradeTrendsFilterList(0);
    },
    getTradeTrendsFilterList(value) {
      // 使用当前选中的条件
      // 这里可以添加过滤逻辑
    },

    suppleEchart() {
      if (this.$refs.SupplyChainEchart == undefined) return;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          right: "10",
          top: "0px",
          icon: "rect", //
          //  width: '200px'
          // 其他图例配置项
          // ...
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: true, // 不显示 x 轴线
            },
            axisTick: {
              show: false, // 不显示 x 轴上的间隔点
            },
            data: this.echartsSeveryear,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: this.Arrlist,
      };

      this.echartsBox.setOption(option, true);
    },
    getData() {
      const currentCondition =
        this.DataComparisonList[this.DataComparisonAcaive].conditions;
      getTradeTrends({
        startMonth: currentCondition.datePicker[0],
        type: this.activeIEports,
        endMonth: currentCondition.datePicker[1],
        // aaaid:this.Companyid,
        hsCode: currentCondition.HsCode,
        countryCode: this.$route.query.id3a,
        countryCodeFilter: this.Country,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;
        }
      });
    },
  },
  computed: {
    calDate() { 
      const currentCondition =
      this.DataComparisonList[this.DataComparisonAcaive].conditions;
     
      currentCondition .datePicker=[currentCondition.beginDate,currentCondition.endDate];
      if(!currentCondition.beginDate && !currentCondition.endDate){
        currentCondition.datePicker=[];
      }
      return currentCondition.datePicker;
    }
  },
};
</script>
<style scoped>
.operations-headspan{
  color: #009ea7;
}
.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.table-content-color {
  color: #009ea7;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}

/deep/ .el-tag.el-tag--info {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #1a2332;
  font-size: 1.285714rem;
  border-radius: 23px !important;
  border: 1px solid #cccccc !important;
}

/deep/ .el-icon-close {
  background-color: #ff6a6a !important;
  color: #ffffff !important;

  /* display: none !important; */
}

.Product_Supply_select {
  padding: 20px;
  background: #f5f5f5;
}

/*cssStart*/
/deep/ .el-select-dropdown {
  max-width: 400px;
}

.DataComparison {
  border-radius: 10px 10px 0px 0px;
  padding: 15px 20px;
  margin-right: 14px;
  display: inline-block;
}

.DataComparisonBlack {
  background: #f5f5f5;
  color: #1a2332;
}

.DataComparisonActive {
  border-radius: 10px 10px 0px 0px;
  background: #009ea7;
  color: #ffffff;
}

.DataComparison_tab {
  font-size: 20px;
}

.data_comp_con_sear {
  padding: 20px;
  background: #ffffff;
}

.data_com_con_tip {
  line-height: 32px;
}

.data_select_lab {
  font-size: 20px;
  width: 200px;
  flex: none;
}

::v-deep .el-date-editor .el-range-input {
  font-size: 16px;
}

.over_chart_title {
  padding: 30px 20px;
}
  
.width_100 {
  width: 100%;
  gap: 80px;
}

.width_50 {
  width: 50%;
}

.data_select {
  width: 100%;
}

::v-deep .data_select .iconfont {
  font-size: 22px;
  color: #1a2332;
}
.trade_icon_tip_box {
  flex-direction: column;
  height: 266px;
}
.trade_icon_tip_box .iconfont {
  font-size: 100px;
  line-height: 110px;
  color: #ccc;
  margin-bottom: 15px;
}
.trade_icon_tip_box p {
  text-align: center;
  margin-bottom: 10px;
}
@media (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .DataComparison {
    border-radius: 10px 10px 0px 0px;
    padding: 12px 15px;
    margin-right: 10px;
  }

  .data_comp_con_sear,
  .Product_Supply_select {
    padding: 15px;
  }

  .DataComparison_tab {
    font-size: 16px;
  }

  .data_com_con_tip {
    line-height: 24px;
  }

  ::v-deep .el-date-editor .el-range-input {
    font-size: 14px;
  }

  .over_chart_title {
    padding: 22px 15px;
  }

  .com_search_title {
    font-size: 20px;
  }

  .data_select_lab {
      font-size: 16px;

    width: 150px;
  }

  .width_100 {
    gap: 60px;
  }
  .trade_icon_tip_box {
    height: 200px;
  }
  .trade_icon_tip_box .iconfont {
    font-size: 76px;
    line-height: 80px;
    margin-bottom: 12px;
  }
  .trade_icon_tip_box p {
    margin-bottom: 7px;
  }
}

@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }

  .DataComparison {
    border-radius: 6px 6px 0px 0px;
    padding: 10px 12px;
    margin-right: 9px;
  }

  .data_comp_con_sear,
  .Product_Supply_select {
    padding: 12px;
  }

  .DataComparison_tab {
    font-size: 14px;
  }

  ::v-deep .el-date-editor .el-range-input {
    font-size: 12px;
  }

  .over_chart_title {
    padding: 20px 12px;
  }

  .com_search_title {
    font-size: 18px;
  }

  .data_select_lab {
       font-size: 14px; 
    width: 140px;
  }

  .width_100 {
    gap: 50px;
  }
  .trade_icon_tip_box {
    height: 180px;
  }
  .trade_icon_tip_box .iconfont {
    font-size: 66px;
    line-height: 70px;
    margin-bottom: 10px;
  }
  .trade_icon_tip_box p {
    margin-bottom: 6px;
  }
}
</style>
